import {defineMessages} from 'react-intl.macro';

export const messages = defineMessages({
  'CHECKPOINT_TYPE_ASSIGNED_WITH_WORKS': {
    defaultMessage: 'This checkpoint type is associated to work, please remove these entries first.',
    id: 'CHECKPOINT_TYPE_ASSIGNED_WITH_WORKS'
  },
  'CHECKPOINT_TYPE_HAS_CHECKPOINTS': {
    defaultMessage: 'checkpoint type must not have associated checkpoints',
    id: 'CHECKPOINT_TYPE_HAS_CHECKPOINTS'
  },
  'checkpointTypes.list.actions': {
    defaultMessage: 'Actions',
    id: 'checkpointTypes.list.actions'
  },
  'checkpointTypes.list.actions.delete.areYouSure': {
    defaultMessage: 'Are you sure you want to delete the checkpoint type "<b>{displayName}</b>"?',
    id: 'checkpointTypes.deletion.areYouSure'
  },
  'checkpointTypes.list.actions.delete.description': {
    defaultMessage: '<i>NOTE</i>: Be aware that' +
      ' this action will also remove the type from any checkpoints.',
    id: 'checkpointTypes.deletion.description'
  },
  'checkpointTypes.list.actions.delete.modalTitle': {
    defaultMessage: 'Delete Checkpoint Type?',
    id: 'checkpointTypes.actions.delete.modalTitle'
  },
  'checkpointTypes.list.created': {
    defaultMessage: 'Created',
    id: 'checkpointTypes.list.created'
  },
  'checkpointTypes.list.delete': {
    defaultMessage: 'Delete',
    id: 'checkpointTypes.list.delete'
  },
  'checkpointTypes.list.delete.failure': {
    defaultMessage: 'Checkpoint Type deletion failed',
    id: 'checkpointTypes.list.deletion.failure'
  },
  'checkpointTypes.list.delete.success': {
    defaultMessage: 'Checkpoint Type deleted successfully',
    id: 'checkpointTypes.list.deletion.success'
  },
  'checkpointTypes.list.description': {
    defaultMessage: 'Description',
    id: 'checkpointTypes.list.description'
  },
  'checkpointTypes.list.displayedRows': {
    defaultMessage: '{from, number}-{to, plural, =-1 {{count, number}} other {#}} of {count, plural, =-1 {more than {to, number}} other {#}}',
    id: 'checkpointTypes.list.displayedRows'
  },
  'checkpointTypes.list.empty.action': {
    defaultMessage: 'Create a checkpoint type',
    id: 'checkpointTypes.list.empty.action'
  },
  'checkpointTypes.list.empty.primary': {
    defaultMessage: 'No checkpoint types',
    id: 'checkpointTypes.list.empty.primary'
  },
  'checkpointTypes.list.empty.secondary': {
    defaultMessage: 'Your account has no checkpoint types yet.',
    id: 'checkpointTypes.list.empty.secondary'
  },
  'checkpointTypes.list.loading': {
    defaultMessage: 'Loading...',
    id: 'checkpointTypes.list.loading'
  },
  'checkpointTypes.list.name': {
    defaultMessage: 'Name',
    id: 'checkpointTypes.list.name'
  },
  'checkpointTypes.list.rowsPerPage': {
    defaultMessage: 'Rows per page',
    id: 'checkpointTypes.list.rowsPerPage'
  },
  'checkpointTypes.list.update': {
    defaultMessage: 'Update',
    id: 'checkpointTypes.list.update'
  },
  'checkpointTypes.list.updated': {
    defaultMessage: 'Updated',
    id: 'checkpointTypes.list.updated'
  }
});
